import { useEffect, useRef } from "react";
import { Row, Form, Col } from "react-bootstrap";
import { agreeWithCustomerTermsState } from "atoms";
import { useRecoilState } from "recoil";
import { CartModel } from "atoms/models";
import "components/Confirm/confirm.scss";

const CustomerServiceAgreementCheckbox: React.FC<{ cart: CartModel; setServiceAgreementModal: Function }> = ({ cart, setServiceAgreementModal }) => {
  const [customerAgreedWithTerms, setCustomerAgreedWithTerms] = useRecoilState(agreeWithCustomerTermsState);
  const htmlRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      // Remove inline styles after HTML is rendered
      if (htmlRef.current) {
        // Remove inline styles from all elements inside htmlRef
        const elementsWithStyles = htmlRef.current.querySelectorAll("*");
        elementsWithStyles.forEach((element) => {
          element.removeAttribute("style");
          element.removeAttribute("width");
        });

        const tableElement = htmlRef.current.querySelector('table[cellpadding="7"]') as HTMLTableCellElement;

        if (tableElement) {
          tableElement.style.width = "100%";
        }
      }
    }, 2000);
  }, []);

  return (
    <>
      <Row className="mt-2">
        <Col className={`d-flex ${cart?.isCurrentCustomer || cart?.promotionCode?.enabled ? "justify-content-end me-3" : "justify-content-center"}`}>
          {cart.isServiceAgreementRequired ? (
            <>
              <Form.Check id="tc" className="me-3 checkbox-vertical-align">
                <Form.Check.Input
                  checked={customerAgreedWithTerms}
                  disabled={customerAgreedWithTerms}
                  className="align-text-bottom"
                  onChange={() => {
                    setCustomerAgreedWithTerms(!customerAgreedWithTerms);
                    setServiceAgreementModal(false);
                  }}
                />
              </Form.Check>
              <div>
                <label htmlFor="tc" className="align-middle mb-3">
                  I agree with the Customer Service Agreement.
                </label>
              </div>
            </>
          ) : null}
        </Col>
      </Row>
    </>
  );
};

export default CustomerServiceAgreementCheckbox;
